import type { FC } from "react";
import type { Opening } from "../../../utils/models";
import { AccentIconTile } from "../../UIToolkit/molecules/AccentIconTile";
import { ORIGIN_GROUP_TONE, ORIGIN_KIND_ICON } from "./requestOriginMeta";

/** One cause's tile: the kind's glyph, toned by its group. */
export const RequestOriginTile: FC<{ opening: Opening }> = ({ opening }) => {
	const Icon = ORIGIN_KIND_ICON[opening.kind];
	return (
		<AccentIconTile size="xs" tone={ORIGIN_GROUP_TONE[opening.group]}>
			<Icon />
		</AccentIconTile>
	);
};
